import actions from "actions";
import React, { Component } from "react";
import { connect } from "react-redux";
import StudyGroupUserNavigation from "../../components/StudyGroupsUser/StudyGroupUserNavigation";
import StudyGroupUserTitle from "../../components/StudyGroupsUser/StudyGroupUserTitle";
import { loadCurrentWebinarsSaga } from "../../actions/api";
import constants from "constants";
import { CurrentWebinarAlert } from "../StudyGroups/StudyGroupUserPage";

const { getStudygroup } = actions;

const { CURRENT_WEBINARS } = constants;

const tabs = [
  { label: "Meetings", url: "/webinars/all" },
  { label: "Statistics", url: "/statistics" },
  { label: "Members", url: "/members" },
  { label: "Resources", url: "/resources" },
  // { label: "Chat", url: "/chat" },
];

class StudyGroupSuperHostPage extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: true };
  }

  componentWillMount() {
    this.props.loadStudyGroup(this.props.params.id);
    this.props.loadCurrentWebinars(1, {
      group_id: this.props.params.id,
    });
  }

  componentDidUpdate(prev) {
    if (prev.current.count !== this.props.current.count) {
      this.setState({ isOpen: true });
    }
    if (prev.location.pathname !== this.props.location.pathname) {
      this.props.loadCurrentWebinars(1, {
        group_id: this.props.params.id,
      });
    }
  }

  handleClose = () => this.setState({ isOpen: false });

  render() {
    const { studygroup, params, location, current } = this.props;
    const groupId = params.id;

    const { isOpen } = this.state;

    const hasWebinars = Boolean(current.count);

    const isUpcomingPage = location.pathname.includes("upcoming");

    const isAlertShowed = isOpen && hasWebinars && isUpcomingPage;

    return (
      <main className="site--width">
        {isAlertShowed && (
          <CurrentWebinarAlert handleClose={this.handleClose} />
        )}
        <StudyGroupUserTitle title={studygroup.title || ""} />
        <StudyGroupUserNavigation
          tabs={tabs}
          groupId={groupId}
          activeUrl={location.pathname}
        />
        {this.props.children}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.users.user.role,
  studygroup: state.studygroups.studygroup,
  current: state.webinars[CURRENT_WEBINARS],
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  loadStudyGroup: (id) => dispatch(getStudygroup(id)),
  loadCurrentWebinars: (page, params) =>
    dispatch(loadCurrentWebinarsSaga(page, params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperHostPage);



// WEBPACK FOOTER //
// ./src/containers/StudyGroupSuperHostPage/index.jsx